import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-create-order',
  templateUrl: './create-order.component.html',
  styleUrls: ['./create-order.component.css']
})
export class CreateOrderComponent implements OnInit {

  constructor(private orderService:ServiceService) { }

  //searchCustomerUrl="http://192.241.151.66:5000/viewCustomers?customer_name="
  //searchProductUrl="http://192.241.151.66:5000/viewProducts?product_name="
  //createSaleUrl="http://192.241.151.66:5000/saleorder"
  searchCustomer=""
  searchProduct=""
  body={
    date_time:"",
    total_amount:0,
    customer_id:"",
    customer_name:"",
    customer_code:"",
    status:"Active",
    amount_vat_in:"true",
    entity: "SHAJI PAINTS",
    currency:"AED",
    contract:"",
    inventory_service_list:[]

  }
  data={
    c_name:"",
    company_id:"",
    p_name:"",
    product_id:"",
    b_name:"",
    cat_name:"",
    price:"",
    quantity:"",
    UOM_name:"",
    UOM_id:"",
    
  }

  isShownCustomer=false
  isShownProduct=false
  isAddProduct=false
  isItemselected=false
  NoQuentity=""
  NoProduct=""
  customers:any=[]
  products:any=[]
  NoCustomer=""
  order:any=[]
  order1:any=[]
  today= new Date();
  Subtotal=1
  CompanyPrice=""
  isChange=false
  alert=""
  count=0

//--------function for show the alert
shown(){
  this.isChange=false;
}

//-------function for check quentity field----------------------------
SetValue(value:any)
{
  this.data.quantity=value
  this.NoQuentity=""
}
//-------function for check product name field----------------------------
SetProduct(value:any)
{
  this.data.p_name=value
  this.NoProduct=""
}
  //-----------------------function for show product card--------------
  AddProduct()
  {
    console.log("call add")
    if(this.data.c_name=="")
    {
      this.NoCustomer="select a valid customer"
    }
    else
    {
      this.isAddProduct=true
    }
  }

//---------------function for add item one by one----------------------
AddOne(){

  //var count=this.order.length
  this.count=this.count+1

  if(this.data.p_name!="" && this.data.quantity!="")
  {
  
 /*-----------new--------------------------*/
 var obj = {
  item_id:this.data.product_id,
  item_name:this.data.p_name,
  content:this.data.p_name,
  quantity:this.data.quantity,
  uom_id:this.data.UOM_id,
  uom_name:this.data.UOM_name,
  unit_price:this.data.price,
  val:this.count,
  amount:+(+this.data.quantity*+this.data.price).toFixed(2),
  vat_percentage:5,
  vat_amount:0,
  total:0

};
 /*-------------------------------------------*/
  this.order.push(obj)
  this.isItemselected=true
  this.data.p_name=""
  this.data.quantity=""
  this.data.price=""
  this.data.b_name=""
  
  }
  else if(this.data.p_name=="" && this.data.quantity!=""){
      
    this.NoProduct="Select a product"
  }
  else if(this.data.quantity=="" && this.data.p_name!=""){

    this.NoQuentity="Select the quantity"
    
  } 
  else{

    this.NoProduct="Select a product"
    this.NoQuentity="Select the quantity"

  }

}
//--------------function for get quentity-------------------
SetQuantity(value1:any,count:any)
{
  
   this.order[count-1].quantity=value1
   
}
//--------------function for set total price-----------
SetTotal(quantity:any,unit_pice:any)
{
     // this.Subtotal=quantity*unit_pice
      //console.log("call function")
      var num=quantity*unit_pice 
      return num.toFixed(2)
}

//----------function for delete selected product----------
delete(key:any)
{

  this.order.forEach((value1:any,index:any)=>{
    if(value1.val==key) this.order.splice(index,1);
});
  //this.order.splice(value1, 1); 
}
//-------function for place an ordr-----------------------------
PlaceOrder()
{
  console.log("place order detail",this.order)
  this.body.date_time = formatDate(this.today, 'dd-MM-yyyy hh:mm:ss a', 'en-US', '+0530');

  //---find vat amount and total amount of each order------
  var FinalAmount=0
  for(var i=0;i<this.order.length;i++)
  {
    this.order[i].vat_amount=.05*this.order[i].amount;
    this.order[i].total=this.order[i].amount+ this.order[i].vat_amount;
    FinalAmount=FinalAmount+this.order[i].total;
  }

  this.body.total_amount=FinalAmount;
  this.body.inventory_service_list=this.order
  console.log("Final=",this.body)
  /*------------API for sale order creation--------------------*/
  this.orderService.CreatesaleOrder(this.body).subscribe((res) => {
    if(res.sucess)
    {
      this.alert="Sucess!! Your order number is "+res.data.saleorder_number
    }
    console.log("alert=",res)
   })

  this.isChange=true;

}
//-------------function for search customer--------------------
SearchCustomer(){

  this.NoCustomer=""
  if(this.data.c_name!='')
  {
  this.isShownCustomer=true;
  }
  else
  {
     this.data.company_id=""
     this.body.customer_code=""
     this.body.contract=""
  }
  this.searchCustomer=this.data.c_name
  this.orderService.SearchCustomer(this.searchCustomer).subscribe((res)=>{
  this.customers=res.data
  console.log("output=",this.customers)
 
  })
}
//---------function for getting searched customer id---------------
getCustomerId(c:any){
     
     this.isShownCustomer=false
    // this.searchCustomer=value2
     //this.customer_id=value1
    this.data.c_name=c.customer_name
    this.data.company_id=c.customer_id;
    this.CompanyPrice=c.company_price
    console.log("price1=",this.CompanyPrice)

    this.body.customer_id=c.customer_id;
    this.body.customer_name=c.customer_name;
    this.body.customer_code=c.customer_code;
    this.body.contract=c.contract;
    
}

 //-------------function for search product--------------------
 SearchProduct(){
  if(this.data.p_name!='')
  {
  this.isShownProduct=true;
  }
  else{
    this.data.p_name=""
    this.data.quantity=""
    this.data.price=""
    this.data.b_name=""
  }
  this.searchProduct=this.data.p_name
  this.orderService.SearchProduct(this.searchProduct).subscribe((res)=>{
  this.products=res.data

  })
}
//---------function for getting searched product id---------------
getProductId(c:any){
     
     this.isShownProduct=false
     this.data.p_name=c.product_name  
     this.data.product_id=c.product_id;
     this.data.b_name=c.product_brand_name;
     this.data.cat_name=c.product_category_name;
     this.data.UOM_id=c.product_uom_main_id;
     this.data.UOM_name=c.product_uom_main;

     //this.data.price=c.supplier_price;
     console.log("price=",this.CompanyPrice)
     //---condition for set the unit price------
     if(this.CompanyPrice=='RAK STD PRICE')
     {
       this.data.price=c.rak_std_price;

     }
     else if(this.CompanyPrice=='AL QUOZ STD PRICE')
     {
       this.data.price=c.al_quiz_std_price;
     }
     else if(this.CompanyPrice=='DIP STD PRICE')
     {
       this.data.price=c.dip_std_price;
     }
     else if(this.CompanyPrice=='QUSAIS STD PRICE')
     {
       this.data.price=c.qusais_std_price;
     }
     else if(this.CompanyPrice=='SAJAA STD PRICE')
     {
       this.data.price=c.sajaa_std_price;
     }
     else if(this.CompanyPrice=='AWEER STD PRICE')
     {
       this.data.price=c.aweer_std_price;
     }
     else if(this.CompanyPrice=='AL AIN STD PRICE')
     {
       this.data.price=c.al_ain_std_price;
     }
     else if(this.CompanyPrice=='SHJ STD PRICE')
     {
       this.data.price=c.shj_std_price;
     }
     else if(this.CompanyPrice=='ABU DHABI STD PRICE')
     {
       this.data.price=c.abudhabi_std_price;
     }
     else{
       this.data.price=c.supplier_price
     }
}


  ngOnInit(): void {
    
  }

}
